module.exports = __webpack_public_path__ + "img/EE.92ed64b5.svg";